import React from 'react';
import SharedHeader from './SharedHeader';
import SharedFooter from './SharedFooter';

export default function Layout({ children }) {
    return (
        <div className="flex flex-col min-h-screen bg-[#F9FAFB] font-sans text-gray-900">
            <SharedHeader />
            {/* Add top padding to account for the fixed header height */}
            <main className="flex-grow pt-[80px]">
                {children}
            </main>
            <SharedFooter />
        </div>
    );
}
